module.exports = __webpack_public_path__ + "static/media/more.355246b9.png";